<button mat-raised-button [disabled]="disabled" class="primary" (click)="delete();" type="button"><mat-icon>delete_forever</mat-icon> {{label}}</button>
